/**
 * @generated SignedSource<<523ee7d7a22dd36ed609d8048cb066a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShareProfileButton_userProfile$data = {
  readonly analyticsId: number;
  readonly displayUsername: string;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "ShareProfileButton_userProfile";
};
export type ShareProfileButton_userProfile$key = {
  readonly " $data"?: ShareProfileButton_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShareProfileButton_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShareProfileButton_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "cbab20a97e06b58d9c9828bd0de46547";

export default node;
